const home = require('@/translations/ja/home');
const contactUs = require('@/translations/ja/contactUs');
const footer = require('@/translations/ja/footer');
const header = require('@/translations/ja/header');
const summary = require('@/translations/ja/summary');
const workDetails = require('@/translations/ja/workDetails');
const howWeWork = require('@/translations/ja/howWeWork');
const buyFrames = require('@/translations/ja/buyFrames');
const checkout = require('@/translations/ja/checkout');
const login = require('@/translations/ja/login');
const frameBrowser = require('@/translations/ja/frameBrowser');
const company = require('@/translations/ja/company');
const alert = require('@/translations/ja/alert');
const employment = require('@/translations/ja/employment');
const privacypolicy = require('@/translations/ja/privacypolicy');
const faq = require('@/translations/ja/faq');
const customerservice = require('@/translations/ja/customerservice');
const tnc = require('@/translations/ja/tnc');
const tncg = require("@/translations/ja/tncg");
const notation = require("@/translations/ja/notation");
const certificate = require("@/translations/ja/certificate");
const emerging = require("@/translations/ja/emerging");
const events = require("@/translations/ja/events");

const ja = {
  ...home,
  ...contactUs,
  ...footer,
  ...header,
  ...summary,
  ...workDetails,
  ...howWeWork,
  ...buyFrames,
  ...checkout,
  ...login,
  ...frameBrowser,
  ...company,
  ...alert,
  ...employment,
  ...privacypolicy,
  ...faq,
  ...customerservice,
  ...tnc,
  ...tncg,
  ...notation,
  ...certificate,
  ...emerging,
  ...events
};

module.exports = ja;
